import React from 'react'
import styles from './styles.module.css'

const TableParam = ({ children, type = '' }) => {

  return (
    <>
      <span className={styles.container}>
        <span>{children}</span>
        {!!type && <span className={styles.type} data-testid="param-type">{type}</span>}
      </span>
    </>
  )
}

export default TableParam
